import axiosInstance from "../configs/axios";

export interface UserNotification {
  uuid: string;
  type: string;
  title: string;
  message: string;
  read: boolean;
  createdAt: string;
}

export interface NotificationListResponse {
  items: UserNotification[];
  unreadCount: number;
}

export const notificationService = {
  list: async (limit = 30): Promise<NotificationListResponse> => {
    const response = await axiosInstance.get(`/notifications?limit=${limit}`);
    return response.data?.data ?? { items: [], unreadCount: 0 };
  },

  markAllRead: async (): Promise<void> => {
    await axiosInstance.post("/notifications/read");
  },

  markOneRead: async (uuid: string): Promise<void> => {
    await axiosInstance.post(`/notifications/${uuid}/read`);
  },
};
